/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="47"
        height="47"
        viewBox="0 0 47 47"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#edf0f3"
          stroke="#fff"
          d="M23.5 46A22.5 22.5 0 1 0 1 23.5 22.5 22.5 0 0 0 23.5 46Z"
          fillRule="evenodd"
          strokeWidth="2"/>
        <circle
          cx="24"
          cy="23"
          r="18"
          fill="none"
          stroke="#ffb81c"
          className="icon-stroke icon-accent"
          strokeWidth=".75"/>
        <g
          fill="none"
          stroke="#0e497b"
          className="icon-stroke icon-base"
          strokeWidth=".5"
          strokeLinecap="round">
          <path d="m32.97 19.23-8.54 9.88M15.93 19.21l8.5 9.9M28 19.23l-3.5 9.27M20.59 19l3.84 9.75"/>
        </g><path
          fill="none"
          d="m23 29-8-10M24 29l4-9M24 29l10-8"/><path
          fill="#0e497b"
          stroke="#0e497b"
          d="M30.15 17.93a3.42 3.42 0 0 1 .64 0 3.32 3.32 0 0 1 1.84.84c-2.34-6.81-8.23-6.93-8.29-6.93-6 .19-7.83 5.25-8.26 6.83a3.25 3.25 0 0 1 2.24-.82A3.76 3.76 0 0 1 20.67 19l.61-.39a5 5 0 0 1 3.38-1.12A5.69 5.69 0 0 1 28 19.05a4 4 0 0 1 2.11-1.12m2.7 1.49a3.24 3.24 0 0 0-2.09-1.19 3.4 3.4 0 0 0-2.62 1.15.13.13 0 0 1-.2 0 5.6 5.6 0 0 0-3.3-1.6 4.72 4.72 0 0 0-3.2 1.07l-.71.46a.17.17 0 0 1-.19 0 4.33 4.33 0 0 0-1-.76 3.11 3.11 0 0 0-1.23-.35 3.13 3.13 0 0 0-2.38 1.06.15.15 0 0 1-.18 0 .18.18 0 0 1-.07-.17c0-.07 1.35-7.33 8.65-7.56.07 0 6.53.13 8.78 7.78a.18.18 0 0 1-.07.19.14.14 0 0 1-.15-.08Z"
          className="icon-fill icon-stroke icon-base"
          fillRule="evenodd"
          strokeWidth=".25"/><path
          fill="#ffb81c"
          d="M24.34 30.5v.26h-.1a.76.76 0 0 0-.57.38.7.7 0 0 0-.06.35.6.6 0 0 0 .39.51 1.75 1.75 0 0 0 .32.12l.42.15a.2.2 0 0 1 .15.23.24.24 0 0 1-.22.22h-.17a.45.45 0 0 1-.44-.28v-.1l-.53.11a.94.94 0 0 0 .25.43.93.93 0 0 0 .57.23v.34h.34v-.33h.2a.77.77 0 0 0 .56-.36.59.59 0 0 0 .06-.45.62.62 0 0 0-.36-.44 4.29 4.29 0 0 0-.5-.19 1.88 1.88 0 0 1-.3-.12.15.15 0 0 1-.11-.11.25.25 0 0 1 .17-.31.41.41 0 0 1 .35.08.49.49 0 0 1 .14.18v.07l.47-.16a.77.77 0 0 0-.17-.29.87.87 0 0 0-.57-.26v-.26Z"
          className="icon-fill icon-accent"
          fillRule="evenodd"/><path
          fill="none"
          stroke="#0e497b"
          d="M19 29.5h11v5H19z"
          className="icon-stroke icon-base"
          strokeWidth=".5"/>
      </svg>

    );
  }
}

Icon.displayName = 'MoneyParachuteWithBorderIcon';

export default Icon;
